import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { Button } from "@mui/material";
import Loading from "../../../components/isLoading";
import { fetchProductsData } from "../../../redux/products/index";
import TableView from "../../../components/Table/TableView";

export default () => {
	const productsData = useSelector((state) => state.productsGlobalStore);
  const dispatch = useDispatch()

	useEffect(() => {
		dispatch(fetchProductsData(0));
	}, []);

	const headCells = [
		{
			id: "title",
			numeric: false,
			label: "Title",
		},
		{
			id: "summary",
			numeric: false,
			label: "Summary",
		},
		{
			id: "benefits",
			numeric: true,
			label: "Benefits",
		},
		{
			id: "requirements",
			numeric: true,
			label: "Requirements",
		},
		{
			id: "status",
			numeric: false,
			label: "Status",
		},
		{
			id: "modified",
			numeric: false,
			label: "Last Modified",
		},
	];

	const rows =
		productsData.data.data?.map((el) => ({
			title: el.title,
			summary: el.summary,
			benefits: el.benefits?.length,
			requirements: el.requirements?.length,
			status: el.status,
			modified: el.updatedAt,
      link:`/products/${el.id}`
		})) || [];

	return (
		<div>
			{productsData.loading && !productsData.data[0] ? (
				<Loading />
			) : (
				<>
					<div
						style={{
							padding: "15px",
							float: "right",
						}}
					>
						<Button
							component={NavLink}
							to="/products/new"
							variant="outlined"
							sx={{
								color: "#E00186",
								border: "1px solid #E00186",
								fontFamily: "Arial",
								"&:hover": {
									color: "#fff",
									backgroundColor: "#E00186",
									border: "1px solid #E00186",
								},
							}}
						>
							Add Product
						</Button>
					</div>
					<div>
						<TableView
							dense
							headCells={headCells}
							rows={rows}
							title="BRAC Products"
						/>
					</div>
				</>
			)}
		</div>
	);
};
